import comp from "./SearchTextEmptyState";
export default comp;
